import useProfile from "api/UserResource/useProfile";
import { FiCheckCircle, FiCircle } from "react-icons/fi";
import UpdateProfile from "./UpdateProfile";
import AccountPage from "./AccountPage";
import AccountLayout from "./AccountLayout";

const MyAccount = () => {
	const { data: profile, isLoading } = useProfile();
	const user = profile?.data;
	const complete = Boolean(user?.first_name && user?.last_name);
	const name = [user?.first_name, user?.last_name].filter(Boolean).join(" ") || "Your profile";
	return (
		<AccountPage>
			<AccountLayout isLoading={isLoading} profile={user}>
				<div className="account-profile-summary">
					<div className="account-profile-summary-main">
						<div className="account-avatar" aria-hidden="true">
							{user?.avatar ? (
								<img src={user.avatar} alt="" />
							) : (
								[user?.first_name?.[0], user?.last_name?.[0]].join("") || "A"
							)}
						</div>
						<div>
							<p className="account-profile-summary-name">{name}</p>
							<p className="account-profile-summary-email">{user?.email}</p>
						</div>
					</div>
					<span className="account-badge">
						{complete ? <FiCheckCircle aria-hidden="true" /> : <FiCircle aria-hidden="true" />}
						{complete ? "Name complete" : "Add your name"}
					</span>
				</div>
				<UpdateProfile
					userId={user?.id}
					firstName={user?.first_name}
					lastName={user?.last_name}
					mobileNumber={user?.mobile_number}
					sex={user?.sex}
					dob={user?.dob}
				/>
			</AccountLayout>
		</AccountPage>
	);
};
export default MyAccount;
